import dataService from '@/services/dataService.js';

export default {
    name: 'vueFormHelper',
    async saveData(parent, tableEnum, objectData, returnPath = undefined) {
        await dataService.upsert(tableEnum, objectData)

        if (returnPath !== undefined)
            parent.$router.push(returnPath);
    },
    userHasPermission(localThis, permissionId) {
        return localThis.$store.getters.getPermissions.map(function(e) { return e.PermissionId; }).indexOf(permissionId) === -1 ? false : true;
    },
    showSnackbarMessage(localThis, messageText, domObject) {
        if (messageText == '') {
            return;
        }

        localThis.msg = messageText;
        var x = domObject.getElementById("snackbar");
        x.className = "show";
        setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    }
}